
import { defineComponent, reactive, ref, onMounted } from 'vue';
import {
  ReloadOutlined,
  ColumnHeightOutlined,
  SettingOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
} from '@ant-design/icons-vue';
import { Container as DragContainer, Draggable } from '@/components/draggable';
import { Pagination, TableFilters, TableColumn, TableColumnSortOrder } from '@/typing';
import { useFetchData } from '@/utils/hooks/useFetchData';
import { useFullscreen } from '@/utils/hooks/useFullscreen';
import { useTableDynamicColumns } from '@/utils/hooks/useTableColumn';
import DragIcon from '@/components/table/drag-icon.vue';
import Orderusedrecordmodel from '@/views/mjstore/orderusedrecord/orderusedrecordmodel/orderusedrecordmodel.vue';
import { useStore } from 'vuex';
import { message } from 'ant-design-vue';
import { useForm } from 'ant-design-vue/es/form';
import SearchRender from '@/components/FormRender/SearchRender.vue';
import getPageConfig from '@/components/page-model/index';
import { useRoute } from 'vue-router';
import { Record } from '@/components/page-model/typing';
import config from '@/views/mjstore/orderusedrecord/mjstore-orderusedrecord';
import { btnTd } from '@/api/typing';

export default defineComponent({
  name: 'Orderusedrecord',
  props: {},
  setup() {
    const store = useStore();
    const current_org = store.getters['user/current_org'];
    const checkAll = ref<boolean>(false);
    const checkAction = ref<boolean>(false);
    const tableHeight = reactive({ y: window.innerHeight - 130 });
    onMounted(() => {
      window.onresize = function () {
        tableHeight.y = window.innerHeight - 130;
      };
    });

    const route = useRoute();
    const path_arr = route.path.split('/');
    const field = { modalType: path_arr[path_arr.length - 1] };

    // 时间区间格式转化 数组-->字符串
    const getRangePicker = (api_fields: Record, record: Record) => {
      const obj: any = {};
      for (const key in api_fields) {
        if (record[api_fields[key] as string]) {
          obj[key] = record[api_fields[key] as string].join(',');
        }
      }
      return obj;
    };

    const {
      searchConfig,
      searchConfigOptions,
      queryData,
      baseColumns,
      slotList,
      titleList,
      api_fields,
      event_obj,
      btn_list,
    } = config();

    if (searchConfig.fields) {
      for (let i = 0; i < searchConfig.fields.length; i++) {
        // 预先填充 placeholder
        let filed_dict = searchConfig.fields[i];
        if (!filed_dict.placeholder) {
          let pre_str = filed_dict.type == 'input' ? '请填写' : '请选择';
          filed_dict.placeholder = pre_str + filed_dict.label;
        }
        // 预先填充 校验message
        let search_rule_dict = searchConfig.rules[filed_dict.name];
        if (search_rule_dict) {
          if (!search_rule_dict.message) {
            search_rule_dict.message = filed_dict.placeholder;
          }
        }
      }
    }

    event_obj?.on('refresh', () => {
      reload();
    });
    event_obj?.on('reset_and_reload', () => {
      reload();
    });
    const {
      state: columnState,
      dynamicColumns,
      dynamicColumnItems,
      handleColumnAllClick,
      handleColumnChange,
      reset,
      move,
    } = useTableDynamicColumns(baseColumns as TableColumn[], {
      checkAll: false,
      needRowIndex: false,
    });
    const [elRef, screenState, { setFull, exitFull }] = useFullscreen();
    const modelRef = reactive({
      ...searchConfig.model,
    });
    const { resetFields, validateInfos } = useForm(searchConfig.model, searchConfig.rules);

    const {
      stripe,
      reload,
      setPageInfo,
      context: state,
    } = useFetchData(queryData, {
      current: 1,
      pageSize: 20,
      tableSize: 'small', // 'default' | 'middle' | 'small'
      stripe: true,
      requestParams: {
        ...modelRef,
        ...getRangePicker(api_fields.rangepicker, modelRef),
      },
    });
    const handleTableChange = (
      { current, pageSize }: Pagination,
      filters: TableFilters,
      sorter: TableColumnSortOrder,
    ) => {
      console.log(sorter);
      let filter_map: any = {};
      for (let key in filters) {
        filter_map[key] = filters[key].map((x: any) => x.toString()).join(',');
      }
      setPageInfo({
        current,
        pageSize,
        ...modelRef,
        ...filter_map,
      });
      reload();
    };

    const search = () => {
      setPageInfo({
        current: 1,
        ...searchConfig.model,
        ...getRangePicker(api_fields.rangepicker, searchConfig.model),
      });
      reload();
    };

    let currentRecord = reactive({ name: '', mid: 0 });

    // 字段对应错误————>转化正确
    const getObjList = (api_fields: Record, record: Record) => {
      const obj: any = {};
      for (const key in api_fields) {
        if (record[api_fields[key] as string]) {
          obj[key] = record[api_fields[key] as string];
        }
      }
      return obj;
    };

    // 接口返回时间，格式优化
    const getDateTime = (time: any) => {
      if (time && new Date().getFullYear().toString() == time.substring(0, 4)) {
        time = time.substring(5, 16);
      } else if (time) {
        time = time.substring(0, 16);
      }
      return time;
    };
    const getDate = (time: any) => {
      if (time && new Date().getFullYear().toString() == time.substring(0, 4)) {
        time = time.substring(5, 10);
      } else if (time) {
        time = time.substring(0, 10);
      }
      return time;
    };
    const getTime = (time: any) => {
      if (time) {
        time = time.substring(0, 5);
      }
      return time;
    };

    // 列’默认‘ ’全部‘ 展示的切换
    let old_list: any[] = []; // 定义old_list记录默认数据
    const column_change = () => {
      if (checkAll.value) {
        dynamicColumnItems.value.forEach(org => {
          old_list.push(org);
          let b = {
            ...org,
            checked: true,
          };
          let a: any = {};
          a.target = b;
          handleColumnChange(a, b);
        });
      } else {
        old_list.forEach(org => {
          let a: any = {};
          a.target = org;
          handleColumnChange(a, org);
        });
      }
    };
    const columnAction = () => {
      dynamicColumnItems.value.forEach(org => {
        if (org.key == 'action') {
          let b = {
            ...org,
            checked: checkAction.value,
          };
          let a: any = {};
          a.target = b;
          handleColumnChange(a, b);
        }
      });
    };
    const modifyModal = reactive({
      visible: false,
      obj: {
        org_id: current_org?.id,
        id: -1,
      },
    });
    const custom_btn_list: btnTd[] = [];
    const custom_row_btn_list = [
      {
        name: '退货',
        clazz: 'primary',
        is_show: (record: any) => {
          return (
            record.is_delete == false &&
            (record.card__project_type__p_type == 21 || record.project__project_type__p_type == 20)
          );
        },
        cb: (record: any) => {
          modifyModal.obj = {
            org_id: current_org?.id,
            id: record.id,
          };
          modifyModal.visible = true;
          currentRecord.mid = 0;
        },
      },
    ];
    const modifyModalCancel = () => {
      modifyModal.visible = false;
    };
    const modifyModalOk = (data: any) => {
      if (currentRecord.mid == 0) {
        reload();
      } else {
        Object.assign(currentRecord, data);
      }
      modifyModal.visible = false;
    };

    return {
      getDateTime,
      getTime,
      getDate,
      getRangePicker,
      column_change,
      columnAction,
      checkAll,
      checkAction,
      slotList,
      titleList,
      tableHeight,
      state,
      stripe,
      columnState,
      dynamicColumns,
      dynamicColumnItems,
      currentRecord,
      modelRef,
      resetFields,
      validateInfos,
      // fullscreen
      elRef,
      screenState,
      setFull,
      exitFull,
      handleTableChange,
      search,
      handleColumnChange,
      handleColumnAllClick,
      reset,
      move,
      current_org,
      message,
      reload,
      getPageConfig,
      searchConfig,
      searchConfigOptions,
      getObjList,
      field,
      api_fields,
      btn_list,
      custom_btn_list,
      custom_row_btn_list,
      modifyModal,
      modifyModalOk,
      modifyModalCancel,
    };
  },
  components: {
    DragIcon,
    ReloadOutlined,
    ColumnHeightOutlined,
    SettingOutlined,
    FullscreenOutlined,
    FullscreenExitOutlined,
    Draggable,
    DragContainer,
    SearchRender,
    Orderusedrecordmodel,
  },
});
